// The 'guides' are articles that have been built in React
// For now I have articles and guides all mixed together.
import sortBy from "lodash/sortBy";

import guidesList from "../guides";

export default function getArticlesAndGuides(data, limit = null) {
  const unsorted = data.allMarkdownRemark.edges
    .map(edge =>
      Object.assign({}, edge.node.frontmatter, {
        date: new Date(edge.node.frontmatter.date)
      })
    )
    .filter(x => !x.archive)
    .concat(guidesList);

  const sorted = sortBy(unsorted, x => x.date.getTime()).reverse();
  if (limit) {
    return sorted.slice(0, limit);
  }
  return sorted;
}



// WEBPACK FOOTER //
// ./src/logic/getArticlesAndGuides.js